<!--
  2022-08-02 HHY
优化游戏加载提示动画：①iframe游戏加载时同时显示pge加载动画;
②用户点击play按钮再开始加载游戏，而不是未点击游戏就已自动加载（等待一会儿，有的游戏已经发出背景音乐声或说话声（彩票类））
③若游戏加载时间较长，pge加载动画可点屏幕任意处关闭。
-->
<!--
  2022-08-02 HHY
优化游戏加载提示动画：①iframe游戏加载时同时显示pge加载动画;
②用户点击play按钮再开始加载游戏，而不是未点击游戏就已自动加载（等待一会儿，有的游戏已经发出背景音乐声或说话声（彩票类））
③若游戏加载时间较长，pge加载动画可点屏幕任意处关闭。
-->
<template>
  <div class="iframeContainer">
    <div class="game" v-show="playGame">
      <div class="game-bar">
        <div class="left">
          <div class="icon"><img :src="icon" alt=""/></div>
          <span class="gameName">{{ gameInfo.gameName }}</span>
        </div>
        <div class="deposit" @click="saveUserEvent">
          <div class="fonts-deposit">{{ $t('lang.account.deposit') }}</div>
        </div>
        <div class="close" @click="() => {
        fetchBalance()
        handelClose()
      }">
          <img :src="close" alt="">
        </div>
      </div>
      <!-- <iframe ref="iframe" :src="gameInfo.gameUrl" sandbox="allow-top-navigation allow-scripts allow-popups allow-forms allow-pointer-lock allow-same-origin"></iframe> -->
      <iframe ref="iframe" :src="framSrc"
              sandbox="allow-top-navigation allow-scripts allow-popups allow-forms allow-pointer-lock allow-same-origin"></iframe>
    </div>
    <div class="GameIframeLoading" v-show="isLoading" @click="closeLoading">
      <div>
        <img :src="pgeloading" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/service'
import logo from '@/assets/images/common/logo1.svg'
import cancel from '@/assets/images/common/cancel.svg'
import close from '@/assets/images/common/gameClose.svg'
import icon from '@/assets/images/common/gameIcon.svg'
import {fetchBalance, setCurrentModal} from '@/utils'
import pgeloading from '@/assets/images/common/loading.gif'
import store from '@/store/store'

export default {
  name: 'GameIframe',
  props: ['gameInfo', 'play', 'showGame'],
  data () {
    return {
      logo,
      cancel,
      icon,
      close,
      fetchBalance,
      playGame: this.play,
      loadingTimer: null,
      pgeloading,
      framSrc: '',
      // url: 'https://wbgame.sssjlsss.com/baccarat/index.html?ssoKey=sSgcRaLe9sSwU8KxsRhq8xfBVI8&lang=en-US&apiId=1321&be=moc.sssljsss.ipabewbw&domain_platform=moc.sssljsss.mroftalp-tolsbw&gameId=152&gs=sssljsss',
      isLoading: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  watch: {
    'gameInfo': function (n) {
      if (n) {
        this.fetchGameData()
      } else {
        this.closeGame()
      }
    }
  },
  mounted () {
  },
  methods: {
    fetchGameData () {
      const iframe = this.$refs.iframe
      this.playGame = true
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      window.gtag('config', 'G-7BVS71WNE2', {'page_path': location.pathname})
      window.gtag('event', 'Play', {
        'event_category': this.gameInfo.gameName,
        'event_label': cid
      })
      this.framSrc = this.gameInfo.gameUrl
      //
      if (iframe.attachEvent) {
        iframe.attachEvent('onload', () => {
          this.isLoading = false
        })
      } else {
        iframe.onload = () => {
          this.isLoading = false
        }
      }
    },
    saveUserEvent () {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: 'Deposits from games', UserUniqueId: this.userInfo.UserId}
      request('post', url, data).then(res => {
        this.$router.push('/Deposit')
      }).catch(err => {
        console.log(err)
      })
    },
    handelPlay () {
      this.playGame = true
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      window.gtag('config', 'G-7BVS71WNE2', {'page_path': location.pathname})
      window.gtag('event', 'Play', {
        'event_category': this.gameInfo.gameName,
        'event_label': cid
      })
      this.framSrc = this.gameInfo.gameUrl
      // this.framSrc = this.url
      this.isLoading = true
    },
    handelClose () { // 游戏关闭事件
      this.toClaimBonus()
      this.$store.state.showBonusHint = true // 打开提示有特定数量bonus的气泡框
      if (this.$route.name.toString().toLowerCase() === 'home') {
        const url = 'innovation/deposit-pop-ups/get-pop-ups-info'
        const data = {userId: this.userInfo.UserId}
        request('post', url, data, true).then(res => {
          if (res === -1) {
            this.closeGame()
          } else {
            setCurrentModal(99) // 防止上次弹出与本次弹出相同 然后不弹了
            let popWait = null
            if (localStorage.getItem('popList')) {
              popWait = localStorage.getItem('popList') * 1
            }
            // eslint-disable-next-line no-array-constructor
            let popList = new Array()
            if (store.state.userFirstDeposit === true) { // 首充
              popList.push(1)
            }
            if (store.state.userFirstDeposit === false && res.WheelDiscountPopUps.IsWheelDiscountPopUps && res.WheelDiscountPopUps.Discounts && res.WheelDiscountPopUps.Discounts.length > 0) {
              let arr = {discountList: res.WheelDiscountPopUps.Discounts}
              localStorage.setItem('discountItem', JSON.stringify(arr))
              popList.push(6)
            }
            if (res.LuckyWheelPopUps.IsLuckyWheelPopUps) {
              popList.push(7)
            } else if (res.LuckyWheelPopUps.HaveWheelTask) {
              const today = new Date()
              today.setHours(0, 0, 0, 0)
              const timestamp = Math.floor(today.getTime())
              let modals = store.state.modals
              if (!modals[7].updateDateSpan || timestamp !== modals[7].updateDateSpan) {
                modals[7].updateDateSpan = timestamp
                store.commit('setModals', modals)
                popList.push(7)
              }
            }
            if (store.state.userFirstDeposit === false && res.WelfareDepositPopUps.IsWelfareDepositPopUps) {
              popList.push(8)
            }
            if (popWait !== null) {
              popList.push(popWait)
            }
            // 弹窗队列
            // eslint-disable-next-line no-eval
            if (popList && popList.length > 0) {
              setTimeout(() => {
                let popNow = popList.shift()
                store.commit('setCurrentModalIndex', popNow)
                setCurrentModal(popNow)
                localStorage.setItem('popList', JSON.stringify(popList))
                console.log(localStorage.getItem('popList'))
              }, 350)
            }
            this.closeGame()
          }
        })
      } else {
        this.closeGame()
      }
    },
    closeGame () {
      this.framSrc = ''
      this.$store.commit('setGameInfo', {})
      this.$store.commit('setShowGame', false)
    },
    closeLoading () {
      this.isLoading = false
    },
    /****
     * 2022-08-04 Matt 关闭游戏时更新Bonus https://trello.com/c/4GwUwvYl
     * */
    toClaimBonus () {
      const that = this
      if (!this.userInfo) {
        that.$parent.close()
        return
      }

      const url = '/innovation/account/convertuserbonus'
      const data = {
        userId: this.userInfo.UserId,
        bonusToConvert: 0
      }
      request('post', url, data).then(res => {
        if (res.Code === 1) {
          console.log('Bonus updated.')
        } else {
          console.log(res)
        }
        that.$parent.close()
      }).catch(err => {
        console.log(err)
        that.$parent.close()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.iframeContainer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, .9);
  z-index: 99999;

  .game {
    width: 100vw;
    height: 11.388vw;

    .game-bar {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 11.388vw;
      padding: 0 12vw 0 3.05vw;
      color: #FFFFFF;
      background: #212324;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
      overflow: hidden;

      .left {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon {
          width: 5.277vw;
          height: 4.166vw;
          margin-right: 3.05vw;

          img {
            height: 100%;
            width: auto;
          }
        }

        .gameName {
          width: 52.777vw;
        }

      }
    }

    .deposit {
      position: relative;
      background: #FFDEB8;
      width: 25.833vw;
      height: 6.944vw;
      text-align: center;
      overflow: hidden;
      font-size: 3.888vw;
      font-weight: 400;
      line-height: 6.944vw;
      color: #000000;
      border-radius: 3.611vw;
    }

    .close {
      position: absolute;
      right: 4vw;
    }

    iframe {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      border: none;
      //background-color: #F6D9AA;
      background-color: #FFFFFF;
      width: 100%;
      height: calc(100% - 11.388vw + 1px);
      bottom: 0;
    }
  }

  .displayContainer {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: left;
    width: 100%;
    padding: 4.1666vw;

    img {
      width: 50px;
    }

    .displayContent {
      margin: 20px 0 30px;

      .cancel {
        text-align: right;

        img {
          width: 33px;
        }
      }

      .gameImg {
        position: relative;
        margin-bottom: 30px;

        img {
          width: 100%;
          border-radius: 6px;
        }

        .imgMask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 58.82%, #000000 90%);
        }
      }

      .gameName {
        text-align: center;
        font-size: 30px;
        line-height: 35px;
        color: #F6D9AA;
      }
    }

    .playBtn {
      background-color: #F6D9AA;
      border-radius: 6px;
      text-align: center;
      font-size: 22px;
      line-height: 50px;
      color: #000D2E;
    }
  }

  .GameIframeLoading {
    width: 100vw;
    height: 100vh;
    // background-color: darkred;
    position: relative;
    text-align: center;

    div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 70%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GameIframe/index.vue